import React from "react"
import { useParams } from "react-router"
import { useRiskReport, useRiskReportViewed } from "hooks/useRiskReport"
import styled from "styled-components"
import { HeaderStyle, MyMojoTemplate } from "templates/MyMojoTemplate"
import { desktop, mobile, tablet } from "components/_blueprint/Layout"
import { Header } from "./Header"
import { ApplicantPills } from "./ApplicantPills"
import { LegalAndGeneral } from "./LegalAndGeneral"
import { JointCalculations } from "./JointCalculations"
import { IndividualCalculations } from "./IndividualCalculations"

export const RiskReport = () => {
  const { friendlyId } = useParams<{ friendlyId: string }>()
  const { riskReport, isLoading, error } = useRiskReport(friendlyId)
  useRiskReportViewed(friendlyId, isLoading, error)

  if (isLoading) return <p>Loading . . .</p>
  if (error) return <p>{error}</p>
  if (!riskReport) throw Error(`Risk report data unavailable`)

  return (
    <MyMojoTemplate
      backgroundWave={true}
      headerStyle={HeaderStyle.None}
      footer={<Footer />}
      content={
        <Page>
          <Header riskReport={riskReport} />
          <Body>
            <ApplicantPills riskReport={riskReport} />
            <LegalAndGeneral />
            <JointCalculations riskReport={riskReport} />
            {riskReport.riskIndividual.length > 1 && (
              <IndividualCalculations riskReport={riskReport} />
            )}
          </Body>
        </Page>
      }
    />
  )
}

const Page = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  margin: 0,
})

const Body = styled.div({
  background: "white",
  borderRadius: "50px 50px 0 0",
  maxWidth: 1400,

  margin: "0 auto",

  [mobile]: {
    padding: "0 8px",
  },
  [tablet]: {
    padding: "0 16px",
  },
  [desktop]: {
    padding: "0 32px",
  },
})

const Footer = () => (
  <FooterContainer>
    Mojo is a trading style of Life's Great Limited (06246376). Regulated by the FCA (478215).
    Registered office: The Cooperage, 5 Copper Row, London, SE1 2LH.
  </FooterContainer>
)

const FooterContainer = styled.div({
  background: "#000928",
  color: "white",
  textAlign: "center",

  padding: "32px",
})
